export default "__VITE_ASSET__CGJKP$hr__"